import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GrFormNextLink } from "react-icons/gr";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import newRequest from "../../utils/newRequest";
import imageLiveUrl from "../../utils/urlConverter/imageLiveUrl";
const Relatedassetresources = () => {
  const { t, i18n } = useTranslation();
  const navigate=useNavigate()
    const { isLoading, error, data: ResourcesData } = useQuery("fetchAllgetAllhomeblogs", fetchFeaturesData);

  async function fetchFeaturesData() {
    const response = await newRequest.get("/getAllhomeblogs");
    return response?.data.filter(item => item.status === 1) || [];
  }

  
     const {data: FaqsDataresources } = useQuery("fetchAllFaqsresources", fetchFeaturesresourcesData);

  async function fetchFeaturesresourcesData() {
    const response = await newRequest.get("/getAllheadings");
    return response?.data.filter((item) => item.status === 1) || [];
  }

   const thirdItem = FaqsDataresources?.[1];

  return (
    <div>
      <div className={`p-8 mt-5`}>
        <div className="text-center w-full">
          <h2 className="text-4xl text-center leading-tight font-bold text-[#1d2331] my-10 font-lato">
            {i18n.language === "ar" ? thirdItem?.title_ar || '' : thirdItem?.title || ""}
          </h2>
        </div>
      </div>

      <div className="grid 2xl:grid-cols-3 xl:grid-cols-3 lg:grid-cols-3 gap-3 md:grid-cols-2 grid-cols-1 sm:px-20 px-5 mb-3">
        {/* first Card */}
        {isLoading ? (
          <div>Loading...</div>
        ) : error ? (
          ""
        ) : (
          ResourcesData.map((item) => (
            <div
              className={`h-auto w-full py-1  rounded-md cursor-pointer hover:shadow-2xl hover:border`}
            >
              <img
                src={imageLiveUrl(item?.image)}
                alt=""
                className="w-full h-44 -mt-1 object-cover"
              />
              <div
                className={`w-full ${
                  i18n.language === "ar" ? "text-end" : "text-start"
                }`}
              >
                <div className={`px-3 flex flex-col gap-2 pb-10`}>
                  <Link
                    // to={`/${item?.link}`}
                    className="font-semibold text-secondary sm:text-lg text-base hover:text-primary mt-3"
                  >
                    {i18n.language === "ar" ? item?.title_ar : item?.title}
                  </Link>

                  <h2 className="mb-5 font-extrabold text-xl text-[#1d2331] font-lato">
                    {i18n.language === "ar"
                      ? item?.description_ar
                      : item?.description}
                  </h2>
                  <p className="font-sans text-[#596175] text-xl">
                    {i18n.language === "ar" ? item?.caption_ar : item?.caption}
                  </p>
                  <div
                    className={`mt-7 font-lato text-lg font-bold text-red-600 transition-colors duration-300 ease-in-out flex my-auto ${
                      i18n.language === "ar" ? "justify-end" : "justify-start"
                    }`}
                  >
                    <button onClick={() => navigate(`${item.url}`)}>
                      {t(`${item.button}`)}
                    </button>
                    <GrFormNextLink size={24} className="text-red-600" />
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Relatedassetresources;
